"use client"

/**
 * Mounts the Datadog Browser Logs + RUM SDKs once on the client.
 *
 * Rendered in `app/layout.tsx`'s `<body>`. `initDatadog()` is idempotent
 * and gated on `NEXT_PUBLIC_DD_CLIENT_TOKEN` (RUM additionally requires
 * `NEXT_PUBLIC_DD_RUM_APPLICATION_ID`), so this is a no-op when the token is
 * absent (local dev, token-less pay-page deployments) and RUM stays dark
 * until an application id is provisioned. Renders nothing.
 */

import { useEffect } from "react"

import { initDatadog } from "@/lib/observability/datadog"

export function DatadogInit(): null {
  useEffect(() => {
    initDatadog()
  }, [])

  return null
}
